const parametersTypes = Object.freeze({
  text: 'text',
  file: 'file',
  json: 'json'
})

export { parametersTypes }
